import React from "react";
import { useTranslation } from "react-i18next";
import { Tag } from "../ui/Tag";
import { BookButton } from "../ui/BookButton";
import { Search } from "../assets/search";
import { Book } from "../assets/book";
import { Telephone } from "../assets/telephone";
import { Zip } from "../assets/zip";

export const Pricing = () => {
  const { t } = useTranslation();
  const icons = [<Search />, <Book />, <Zip />, <Telephone />];
  const pricing = t("pricingSection.items", { returnObjects: true }) as {
    title: string;
    subtitle: string;
  }[];
  return (
    <div
      id="pricing"
      className="justify-center lg:max-w-[1100px] mx-auto w-[90%] md:my-[94px]"
    >
      <div className="flex flex-col lg:flex-row  gap-10">
        <div className="flex flex-col gap-6 lg:max-w-[406px] items-center text-center lg:text-start lg:items-start">
          <Tag tag={t("pricingSection.tag")} />
          <p className="text-primary-700 text-[32px] md:text-[40px] font-600 md:tracking-[-1.2px]">
            {String(t("pricingSection.title"))}
          </p>
          <p className="text-neutral-200 text-[18px] font-500">
            {String(t("pricingSection.subtitle"))}
          </p>
          <p className="text-neutral-200 text-[18px] font-500">
            {String(t("pricingSection.secondSubtitle"))}
          </p>
          <p className="text-primary-200 text-[18px] font-700">
            {String(t("pricingSection.build"))}
          </p>
          <div className="w-fit">
            <BookButton />
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-[48px]">
          {pricing.map((eachCard, index) => (
            <div
              key={index}
              className="flex flex-col gap-4 place-items-center text-center md:place-items-start md:text-start"
            >
              <div className="p-2 w-fit rounded-[8px] border border-black/10 bg-white shadow-[0_0_0_4px_rgba(0,0,0,0.02),0_4px_15px_0_rgba(0,0,0,0.08)]">
                {icons[index]}
              </div>
              <p className="text-[20px] font-600 text-primary-700">
                {eachCard.title}
              </p>
              <p className="text-neutral-200 text-[18px] font-500">
                {eachCard.subtitle}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
